export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";